import i18n from 'modules/core/lib/i18n'

import { OptionType } from 'modules/trainings/components/EditModeLayout/types'

export enum AvailableSections {
  basic = 'Basic',
  internal_information = 'InternalInformation',
  completion_configuration = 'CompletionConfiguration',
  relatorio = 'Relatorio',
}

export const options = (relatorioEnabled: boolean): OptionType[] => {
  const sections: OptionType[] = [
    {
      label: i18n.t('trainings.edit_mode.basic_information.title'),
      icon: 'trainings',
      value: AvailableSections.basic,
    },
    {
      label: i18n.t('trainings.edit_mode.internal_information.title'),
      icon: 'file-filled',
      value: AvailableSections.internal_information,
    },
    {
      label: i18n.t('trainings.edit_mode.completion_configuration.title'),
      icon: 'check',
      value: AvailableSections.completion_configuration,
    },
  ]

  if (relatorioEnabled) {
    sections.push({
      label: 'Relatorio Único',
      icon: 'my-documents',
      value: AvailableSections.relatorio,
    })
  }

  return sections
}
